jQuery(function () {

    $('.homepage__slider-js').slick({
        dots: false,
        infinite: true,
        speed: 100,
        autoplaySpeed: 2000,
        fade: true,
        cssEase: 'linear',
        autoplay: true
    });

    $('.header__search .search-js').on('click', function () {
        if ($('.header__search__form-js').hasClass('active')) {
            $('.header__search__form-js').removeClass('active');
        } else {
            $('.header__search__form-js').addClass('active');
        }
    });

    $('.header__top__right .header__langs a[href="#pll_switcher"]').on('click', function () {
        if ($('.header__top__right .header__langs .sub-menu').hasClass('active')) {
            $('.header__top__right .header__langs .sub-menu').removeClass('active');
        } else {
            $('.header__top__right .header__langs .sub-menu').addClass('active');
        }
    });

    if ($('body').hasClass('page-template-template-contact')) {

        const simpleBar = new PerfectScrollbar('.country__box__cont', {

        });

        const simpleBar2 = new PerfectScrollbar('.instructor__box__right', {

        });
        const instructorsBar = new PerfectScrollbar('.instructors__cont', {

        });

        $('.instructor-js').on('click', function () {

            console.log('test');

            var instructorBox = $(this).find('.instructor__box').clone();
            $('.tabs-panel.is-active .instructor__box-js').html(instructorBox);

            $(this).parent().find('.instructor').each(function () {
                $(this).removeClass('active');
            });

            $(this).addClass('active');

            setTimeout(function () {
                const simpleBar2 = new PerfectScrollbar('.instructor__box__right', {

                });
            }, 200);
        });

        $('.country__box-js').on('click', function () {
            var countryID = $(this).data('countryid');

            $('.tabs-panel.is-active .country__box-js').each(function () {
                $(this).removeClass('active');
            });

            $(this).addClass('active');

            $('.tabs-panel.is-active .instructors').each(function () {
                $(this).removeClass('active');
            });
            $('.tabs-panel.is-active .instructors[data-countryid="' + countryID + '"]').addClass('active');

            var instructorBox = $('.tabs-panel.is-active .instructors.active .instructor.active').find('.instructor__box').clone();
            $('.tabs-panel.is-active .instructor__box-js').html(instructorBox);


            setTimeout(function () {
                const instructorsBar = new PerfectScrollbar('.tabs-panel.is-active .instructors.active .instructors__cont', {

                });

                const simpleBar2 = new PerfectScrollbar('.instructor__box__right', {

                });
            }, 200);
        });


        $('.keyword').on('keyup', function () {
            var keyword = $(this).val().toUpperCase();
            console.log(keyword);

            $('.tabs-panel.is-active .country__box-js').each(function () {
                str = $(this).find('.country').text().toUpperCase();
                console.log(str);
                if (str.indexOf(keyword) >= 0) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });

        });

        $('.tabs-title a').on('click', function () {
            $('.keyword').val('');

            $('.country__box-js').each(function () {
                $(this).show();
            });
            setTimeout(function () {
                const simpleBar = new PerfectScrollbar('.tabs-panel.is-active .country__box__cont', {

                });
            }, 300);

            simpleBar.update();

        });

    }

})
